import {
  Flex,
  Text,
  Img,
  Box,
  SimpleGrid,
  Center,
  Spinner,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import LinkWrapperV2 from '../eventsCalendar/LinkWrapperV2';
import { getContentList } from '@/lib/apiService';

interface IMember {
  name: string;
  _id: string;
  logo: { location: string };
  website_link: string;
}
const AllMembers: React.FC<{ collectionKey: string }> = ({ collectionKey }) => {
  const [allMembers, setAllMembers] = useState<IMember[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const res = await getContentList<IMember>(collectionKey, {
          limit: 500,
        });
        setAllMembers(res.content?.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <SimpleGrid
      columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}
      w="100%"
      columnGap="17px"
      rowGap="30px"
    >
      {isLoading ? (
        <Center h="200px">
          <Spinner color="primary.500" />
        </Center>
      ) : (
        <>
          {allMembers
            .sort(
              (a: any, b: any) =>
                a.name.localeCompare(b.name) || a.name - b.name
            )
            .map((item) => (
              <LinkWrapperV2
                key={item?._id}
                link={item?.website_link}
                external
                aria-label="member image"
                chakraLinkProps={{
                  _hover: {
                    textDecoration: 'none',
                  },
                }}
              >
                <Box
                  role="group"
                  cursor="pointer"
                  border="1px solid #EDEDED"
                  height="100%"
                  boxShadow="0px 4px 84px rgba(100, 100, 140, 0.13)"
                >
                  <Center height="86px" w="100%">
                    <Img
                      src={item?.logo?.location}
                      objectFit="contain"
                      alt={item.name}
                      h="90%"
                    />
                  </Center>
                  <Flex alignItems="center" borderTop=" 1px solid #DCE3E9">
                    <Text
                      variant="infoText"
                      fontSize="15px"
                      _groupHover={{
                        color: 'text.green',
                        cursor: 'pointer',
                      }}
                      py="20px"
                      pl="20px"
                    >
                      {item.name}
                    </Text>
                  </Flex>
                </Box>
              </LinkWrapperV2>
            ))}
        </>
      )}
    </SimpleGrid>
  );
};

export default AllMembers;
